module.exports = __webpack_public_path__ + "static/img/firefox.71c5732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/browsers/firefox.png
// module id = yOtu
// module chunks = 0